export const ActionTypes = {
    SET_PRODUCTS : "SET_PRODUCTS",
    SELECTED_PRODUCTS : "SELECTED_PRODUCTS",
    REMOVE_SELECTED_PRODUCTS : "REMOVE_SELECTED_PRODUCTS",
}